import image1 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_detailed_img_1.webp';
import image2 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_detailed_img_2.webp';
import image4 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_detailed_abovefooter.webp';

import artwork from '../../../../assets/images/art_2.png';

const Data_AgnicoEagleExperience = {
  content: (
    <>
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">PROBLEM</h4>

                  <div className="paragraph light-1">
                    <p>
                      Mining operations involve many interconnected environments, and it can be difficult for students and new
                      workers to understand how each stage connects without direct site exposure.
                      <br />
                      <br />
                      Agnico Eagle wanted a way to make the full lifecycle more accessible by giving learners a realistic,
                      first-hand view of the process from sample preparation through mill and lab workflows.
                    </p>
                  </div>
                </div>

                <div className="col-lg-6 second-column">
                  <h4 className="heading heading-small light-2">CHALLENGES</h4>

                  <div className="paragraph light-1">
                    <p>
                      The challenge was translating a complex, multi-stage operation into an experience that is accurate for
                      industry use while still clear and engaging for learners who may have limited mining background.
                      <br />
                      <br />
                      The project also required grounding the content in real operations. To do that, our team visited the
                      Macassa Mine in Ontario and worked directly with onsite teams to document process details, equipment,
                      and context from each area of the lifecycle.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="project-content">
        <div className="project-content-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-large dark-1">
                    A standalone 360 experience that walks users through the broader mining and lab lifecycle.
                  </h2>

                  <div className="paragraph dark-1">
                    <p>
                      The Agnico Eagle 360 Experience is a standalone virtual 360 program designed to help workers and students
                      understand how key operational stages connect across mining and lab processes. Users move through a
                      sequence of environments and workflows that build foundational understanding before entering live
                      operations.
                      <br />
                      <br />
                      By combining field research with immersive storytelling, the program offers a practical learning tool that
                      supports orientation, recruitment, and early-stage workforce development.
                    </p>
                  </div>

                  <div className="heading heading-medium dark-1">
                    <p>Built From Onsite Collaboration</p>
                  </div>

                  <div className="paragraph dark-1">
                    <p>
                      To ensure authenticity, we spent a full day onsite at the Macassa Mine with Agnico Eagle teams across
                      operations. That onsite collaboration informed how we structured the journey through sample handling,
                      preparation, lab processing, and mill-related process stages.
                      <br />
                      <br />
                      The result is an experience that makes a complex lifecycle approachable while preserving operational realism.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image-wrapper">
            <div className="single-image">
              <img src={image1} alt="Agnico Eagle 360 Experience project screenshot 6" loading="lazy" decoding="async" />
            </div>
            <div className="single-image">
              <img src={image2} alt="Agnico Eagle 360 Experience project screenshot 7" loading="lazy" decoding="async" />
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-medium dark-1">Building Insight Through Education and Discussion</h2>

                  <div className="paragraph dark-1">
                    <p>
                      The strongest value of this experience is access. It opens the doors to environments and workflows that
                      many learners would not otherwise see early in their journey, and turns them into a guided foundation
                      for understanding how mining, mill, and lab teams connect.
                      <br />
                      <br />
                      It is designed for students and the broader workforce who are not regularly exposed to these operational
                      areas, giving them shared context that encourages stronger questions, better discussion, and deeper
                      understanding across education, orientation, and workforce awareness initiatives.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image">
            <img src={image4} alt="Agnico Eagle 360 Experience project screenshot 8" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>

      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">RESULTS</h4>

                  <div className="paragraph light-1">
                    <p>
                      The Agnico Eagle 360 Experience highlights how virtual reality and 360 video can deliver meaningful,
                      high-impact engagement without the cost and logistical complexity of repeated onsite exposure.
                      <br />
                      <br />
                      As a scalable and cost-effective solution, this format helps organizations provide consistent lifecycle
                      insight to students, trainees, and future workers while supporting education, orientation, and workforce
                      awareness initiatives.
                    </p>
                  </div>
                </div>

                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                    <div className="paragraph light-1">
                      <p>Virtual 360 Experience</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">CLIENT</h4>
                    <div className="paragraph light-1">
                      <p>Agnico Eagle</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">ONLINE</h4>
                    <div className="paragraph light-1">
                      <p>
                        <a href="https://www.agnicoeagle.com/" target="_blank" rel="noreferrer">
                          www.agnicoeagle.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-content-footer">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-md-6">
                  <h3 className="heading heading-large light-1">
                    Have an idea?
                    <br />
                    Let's explore it together.
                  </h3>
                </div>
                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                  <div className="button-wrapper">
                    <a className="button button-1" href="/Contact">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="artwork artwork-2" aria-hidden="true">
            <img src={artwork} alt="" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </>
  ),
};

export default Data_AgnicoEagleExperience;


